import ValidationMessageModule from './validation-message.module'

export default ValidationMessageModule
